import { Box, TextField, Typography } from '@mui/material';
import i18n from '../../../../../../../i18';
import CharacterCounter from '../../../../../../../components/character-counter';
import EmojiPickerButton from '../../../../../../../components/emoji-picker';

const CustomTextField = ({
    title,
    label,
    lang,
    notificationDetails,
    handleChange,
    titleCharCount,
    titleChartLimit
}) => {
    const handleEmojiClick = (emoji) => {
        const currentTitle = notificationDetails[lang]?.title || '';
        handleChange(lang, 'title', currentTitle + emoji);
    };
    return (
        <Box mb={1}>
            <Typography variant="body2" mb={1}>
                {i18n.t(`columns.${title}`)}
            </Typography>
            <Box mb={1} display={'flex'}>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder={i18n.t(`placeholder.${label}`)}
                    value={notificationDetails[lang]?.title || ''}
                    onChange={(e) => {
                        const newValue = e.target.value || '';
                        if (newValue.length <= titleChartLimit) {
                            handleChange(lang, 'title', newValue);
                        }
                    }}
                    sx={{
                        '& .MuiInputBase-input': {
                            fontSize: 16,
                            height: 32,
                            padding: 1
                        },
                        "marginRight": 1
                    }}
                />
                <EmojiPickerButton onClick={handleEmojiClick} variant="outlined" />
            </Box>
            <CharacterCounter
                charCount={titleCharCount}
                characterLimit={titleChartLimit}
            />
        </Box>
    );
};
export default CustomTextField;
